<script>
    import Coordinates from './Coordinates';
    import debounce from 'lodash-es/debounce';

    export default {
        data() {
            return {
                wontShowAddresses: true,
                addressesLoadedAtLeastOnce: false,
                loading: false,
            };
        },
        methods: {
            async fetchAddressesWithinViewport(map) {
                if (map.$mapObject.zoom < 10) {
                    this.wontShowAddresses = true;
                    return;
                }

                this.wontShowAddresses = false;
                this.loading = true;
                this.addressesLoadedAtLeastOnce = true;

                try {
                    const bounds = map.$mapObject;
                    let polygon = [];

                    const coordinates = new Coordinates();
                    const coordinatesFromMap = coordinates.getCoordinatesFromRectangleShape(bounds);
                    polygon = coordinates.getStringifiedCoordinates(coordinatesFromMap);

                    // Have to send this in because the debounce don't work with async.
                    this.fetchAddresses(polygon, this);
                } catch (error) {
                    this.loading = false;
                }
            },
            fetchAddresses: debounce(async function (polygon, me) {
                const result = await axios.post(route('api.addresses.withinBounds'), { coordinates: polygon });
                me.addresses = result.data;
                me.loading = false;
            }, 2000),
        },
    };
</script>
